module.exports = __webpack_public_path__ + "static/media/warning.f4e591b9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icon/warning.svg
// module id = 482
// module chunks = 0